export default "__VITE_ASSET__DTdBhSCG__"